import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default new Router({
  routes: [
    {
      path: "/index",
      component: () => import("@/views/assembly/assembly.vue"),
      children: [
        {
          path: "/index",
          name: "首页",
          component: () => import("@/views/index/index.vue"),
        },
        {
          path: "/lxvideo",
          component: () => import("@/views/auth/lxvideo"),
        },
        {
          path: "/news/newsDetail",
          name: "新闻详情",
          component: () => import("@/views/index/newsDetail"),
          meta: {
            title: "新闻详情",
          },
        },
        {
          path: "/search/index",
          component: () => import("@/views/search/index"),
          meta: {
            title: "搜索结果",
          },
          props: true,
        },
        {
          path: "/subjectClassification/index",
          component: () => import("@/views/subjectClassification/index"),
          meta: {
            title: "学科分类",
          },
        },
        {
          path: "/bookstore/index",
          redirect: "/bookstore/index",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            title: "书城",
          },
          children: [
            {
              path: "/bookstore/index",
              name: "书城",
              component: () => import("@/views/bookstore/index"),
            },
            {
              path: "/bookstore/bookstoreDetail",
              name: "商品详情",
              component: () => import("@/views/bookstore/bookstoreDetail"),
              meta: {
                title: "商品详情",
              },
            },
            {
              path: "/willingLearn/courseQuestions",
              name: "商品详情",
              meta: {
                title: "商品详情",
                hideMenu: true,
              },
              component: () =>
                import("@/views/willingLearn/bookstore/courseQuestions"),
            },
            {
              path: "/bookstore/preview",
              name: "在线预览",
              component: () => import("@/views/bookstore/answer/preview"),
              meta: {
                title: "在线预览",
              },
            },
            {
              path: "/bookstore/answer",
              name: "在线答题",
              component: () => import("@/views/bookstore/answer/answer"),
              meta: {
                title: "在线答题",
              },
            },
            {
              path: "/bookstore/generateQuestion",
              name: "在线答题",
              component: () =>
                import("@/views/bookstore/answer/generateQuestion"),
              meta: {
                title: "在线答题",
              },
            },
            {
              path: "/bookstore/examination",
              name: "在线考试",
              component: () => import("@/views/bookstore/answer/examination"),
              meta: {
                title: "在线考试",
              },
            },
            {
              path: "/bookstore/paperAnswer",
              name: "在线考试",
              component: () => import("@/views/bookstore/answer/paperAnswer"),
              meta: {
                title: "在线考试",
              },
            },

           
            {
              path: "/bookstore/questionnaire",
              name: "问卷调查",
              component: () => import("@/views/bookstore/answer/questionnaire"),
              meta: {
                title: "问卷调查",
              },
            },
            {
              path: "/bookstore/questionresult",
              name: "问卷详情",
              component: () => import("@/views/bookstore/answer/questionresult"),
              meta: {
                title: "问卷详情",
              },
            },
            {
              path: "/bookstore/answerRecord",
              name: "考试结果",
              component: () => import("@/views/bookstore/answer/answerRecord"),
              meta: {
                title: "考试结果",
              },
            },
            {
              path: "/bookstore/PreviewOnline",
              name: "在线预览",
              component: () => import("@/views/bookstore/answer/PreviewOnline"),
              meta: {
                title: "在线预览",
              },
            },
            {
              path: "/bookstore/analyse",
              name: "考试分析",
              component: () => import("@/views/bookstore/answer/analyse"),
              meta: {
                title: "考试分析",
              },
            },
            {
              path: "/onlineReading/videoread",
              name: "在线阅读",
              component: () =>
                import("@/views/onlineReading/components/videoread"),
              meta: {
                title: "在线阅读",
              },
            },
            {
              path: "/onlineReading/imgread",
              name: "图片阅读",
              component: () =>
                import("@/views/onlineReading/components/imgread"),
              meta: {
                title: "图片阅读",
              },
            },
            {
              path: "/willingLearn/bookstoreDetail",
              name: "书系详情",
              meta: {
                title: "书系详情",
                hideMenu: true,
              },
              component: () =>
                import("@/views/willingLearn/bookstore/bookstoreDetail"),
            },
          ],
        },
        {
          path: "/special/index",
          redirect: "/special/index",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            title: "专题",
          },
          children: [
            //让二级路由和三级路由平级，把二级路由写到三级路由，让二级路由重定向到三级路由，共用一个router-view
            {
              path: "/special/index",
              name: "专题",
              component: () => import("@/views/special/index"),
            },
            {
              path: "/special/specialDetail",
              name: "专题详情",
              component: () => import("@/views/special/specialDetail"),
              meta: {
                title: "专题详情",
              },
            },
            {
              path: "/special/myspecialDetail",
              // name: '专题详情',
              component: () => import("@/views/special/myspecialDetail"),
              meta: {
                title: "专题详情",
              },
            },
            // {
            //   path: '/special/myresourcesDetail',
            //   // name: '专题详情',//资源包详情
            //   component: () =>
            //     import('@/views/special/myresourcesDetail'),
            //   meta: {
            //     title: '资源包详情'
            //   },
            // },
          ],
        },
        {
          path: "/authorLibrary/index",
          redirect: "/authorLibrary/index",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            title: "作者库",
          },
          children: [
            {
              path: "/authorLibrary/index",
              name: "作者库",
              component: () => import("@/views/authorLibrary/index"),
            },
            {
              path: "/authorLibrary/authorDetail",
              name: "作者详情",
              component: () => import("@/views/authorLibrary/authorDetail"),
              meta: {
                title: "作者详情",
              },
            },
          ],
        },

        {
          path: "/coagency/index",
          redirect: "/coagency/index",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            title: "合作机构",
          },
          children: [
            {
              path: "/coagency/index",
              name: "合作机构",
              component: () => import("@/views/coagency/index"),
            },
            {
              path: "/coagency/coagencyDetail",
              name: "机构详情",
              component: () => import("@/views/coagency/coagencyDetail"),
              meta: {
                title: "机构详情",
              },
            },
          ],
        },
        {
          path: "/user",
          name: "个人中心",
          redirect: "/user/index",
          meta: {
            title: "个人中心",
          },
          component: () => import("@/views/user/user.vue"),
          children: [
            {
              path: "/user/index",
              component: () => import("@/views/user/index"),
            },
            {
              path: "/user/myResources",
              name: "我的书架",
              meta: {
                title: "我的书架",
              },
              component: () => import("@/views/user/myResources/index"),
            },
            {
              path: "/user/errorBook",
              name: "错题本",
              meta: {
                title: "错题本",
              },
              component: () => import("@/views/user/errorBook/index"),
            },
            {
              path: "/user/errorBookV2",
              name: "错题本",
              meta: {
                title: "错题本",
              },
              component: () => import("@/views/user/errorBookV2/index"),
            },
            {
              path: "/user/learningRecord",
              name: "学习记录",
              meta: {
                title: "学习记录",
              },
              component: () => import("@/views/user/learningRecord/index"),
            },
            {
              path: "/user/readerTime",
              name: "阅读时长",
              meta: {
                title: "阅读时长",
              },
              component: () => import("@/views/user/readerTime/readerTime"),
            },
            {
              path: "/user/errorBookV2/errDetail",
              name: "错题本详情",
              meta: {
                title: "错题本详情",
              },
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "/user/errorBookV2/errDetail",
                  name: "错题本详情",
                  meta: {
                    hideMenu: true,
                  },
                  component: () => import("@/views/user/errorBookV2/errDetail"),
                },
              ],
            },
            {
              path: "/user/errorBookV2/testPaper",
              name: "错题本",
              component: () => import("@/views/user/errorBookV2/testPaper"),
              meta: {
                hideMenu: true,
                title: "错题本",
              },
            },
            {
              path: "/user/myresourcesDetail",
              component: () => import("@/views/special/myresourcesDetail"),
              meta: {
                hideMenu: true,
                title: "资源包详情",
              },
            },
            {
              path: "/user/mynote",
              name: "我的笔记",
              meta: {
                title: "我的笔记",
              },
              component: () => import("@/views/user/mynote/index"),
            },
            {
              path: "/user/integrate",
              name: "积分明细",
              meta: {
                title: "积分明细",
              },
              component: () => import("@/views/user/integrate/index"),
            },
            {
              path: "/user/accountManage",
              name: "账户管理",
              meta: {
                title: "账户管理",
              },
              component: () => import("@/views/user/accountManage/index"),
            },
            {
              path: "/user/myOrder",
              name: "我的订单",
              meta: {
                title: "我的订单",
              },
              component: () => import("@/views/user/myOrder/index"),
            },
            {
              path: "/user/myEvaluate",
              name: "我的评价",
              meta: {
                title: "我的评价",
              },
              component: () => import("@/views/user/myEvaluate/index"),
            },
            {
              path: "/user/notification",
              name: "消息通知",
              meta: {
                title: "消息通知",
              },
              component: () => import("@/views/user/notification/index"),
            },
            {
              path: "/user/orderDetail",
              redirect: "/user/orderDetail/index",
              name: "订单详情",
              meta: {
                title: "订单详情",
              },
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "/user/orderDetail/index",
                  name: "订单详情",
                  meta: {
                    hideMenu: true,
                  },
                  component: () => import("@/views/user/orderDetail/index"),
                },
                {
                  path: "/user/orderDetail/orderAppraise",
                  name: "订单评价",
                  meta: {
                    title: "订单评价",
                    hideMenu: true,
                  },
                  component: () =>
                    import("@/views/user/orderDetail/orderAppraise"),
                },
              ],
            },
            {
              path: "/user/myCourse",
              name: "我的课程",
              meta: {
                title: "我的课程",
              },
              component: () => import("@/views/user/myCourse/index"),

            },
          ],
        },
        {
          path: "/course/detail",
          name: 'courseDetail',//课程详情
          component: () => import("@/views/user/myCourse/detail"),
          meta: {
            title: "课程详情",
          },
        },
        {
          path: "/bookstore/practiceClass",
          name: "随堂练习",
          component: () => import("@/views/bookstore/answer/practiceClass"),
          meta: {
            title: "随堂练习",
          },
        },
        {
          path: "/bookstore/classDetails",
          name: "随堂详情",
          component: () => import("@/views/bookstore/answer/classDetails"),
          meta: {
            title: "随堂详情",
          },
        },
        {
          path: "/course/discussion",
          name: 'discussion',//讨论
          component: () => import("@/views/user/myCourse/discussion"),
          meta: {
            title: "讨论",
          },
        },
        {
          path: "/cart/index",
          component: () => import("@/views/cart/index"),
          name: "购物车",
          meta: {
            title: "购物车",
          },
        },
        {
          path: "/submitOrder/index",
          component: () => import("@/views/cart/preOrder"),
          name: "提交订单",
          meta: {
            title: "提交订单",
          },
        },
      ],
    },
    {
      path: "/mobileterminalread",
      component: () => import("@/views/mobileterminalread/epubread"),
    },
    {
      path: "/login",
      component: () => import("@/views/auth/login"),
    },
    {
      path: "/register",
      component: () => import("@/views/auth/register"),
    },
    {
      path: "/findbackstep",
      component: () => import("@/views/auth/findBackStep"),
    },
    {
      path: "/findbackstep2",
      component: () => import("@/views/auth/findBackStep2"),
    },
    {
      path: "/download",
      component: () => import("@/views/auth/download"),
    },
    {
      path: "/lxdownload",
      component: () => import("@/views/auth/lxdownload"),
    },
    {
      path: "/lxexplain",
      component: () => import("@/views/auth/lxexplain"),
    },
    {
      path: "/kefu",
      name: "客服",
      component: () => import("@/views/onlineReading/mobileClient/kefu/kefu"),
      meta: {
        title: "客服",
      },
    },
    {
      path: "/onlineReading",
      name: "在线试读",
      component: () => import("@/views/onlineReading/onlineReading"),
      meta: {
        title: "在线试读",
      },
    },
    {
      path: "/resourcesRead",
      name: "征订阅读",
      component: () => import("@/views/onlineReading/resourcesRead"),
      meta: {
        title: "在线试读",
      },
    },
    {
      path: "/booksRead",
      name: "征订阅读",
      component: () => import("@/views/onlineReading/booksRead"),
      meta: {
        title: "在线试读",
      },
    },
    {
      path: "/huiLearning",
      name: "荟学习阅读",
      component: () => import("@/views/onlineReading/huiLearning"),
      meta: {
        title: "在线试读",
      },
    },
    {
      path: "/resourcesRead_v2",
      name: "征订阅读",
      component: () => import("@/views/onlineReading/resourcesRead2"),
      meta: {
        title: "在线试读",
      },
    },
    {
      // 实验学院阅读器
      path: "/textBooksRead",
      name: "征订阅读",
      component: () => import("@/views/onlineReading/booksRead_v2"),
      meta: {
        title: "在线试读",
      },
    },
    {
      // 实验学院数字教材阅读器
      path: "/booksRead-mobile",
      name: "征订阅读",
      component: () => import("@/views/onlineReading/booksReadMobile"),
      meta: {
        title: "在线试读",
      },
    },
    {
      path: "/examination",
      name: "在线考试",
      component: () => import("@/views/bookstore/answer/examination"),
      meta: {
        title: "在线考试",
      },
    },
    {
      path: "/textBookReader",
      name: "数字教材阅读",
      component: () => import("@/views/onlineReading/textBookReader"),
      meta: {
        title: "在线试读",
      },
    },
    {
      path: "/textBookReader_v2",
      name: "征订数字教材阅读",
      component: () => import("@/views/onlineReading/textBookReader_v2"),
      meta: {
        title: "在线试读",
      },
    },
    {
      path: "/error/index",
      component: () => import("@/views/error/index"),
    },
    {
      path: "/app/download",
      component: () => import("@/views/appDownload/appDownload"),
    },
    //  {
    //   path: '/app/lxdownload',
    //   component: () => import('@/views/appDownload/appDownload')
    // },
    {
      path: "/app/read",
      component: () => import("@/views/onlineReading/mobileClient/index"),
    },
    {
      path: "/app/resourceList",
      component: () =>
        import("@/views/onlineReading/mobileClient/resourceList/resourceList"),
    },
    {
      path: "/download/app",
      name: "下载",
      component: () =>
        import("@/views/onlineReading/mobileClient/download/index"),
      meta: {
        title: "下载",
      },
    },
    {
      path: "/Lib/gx",
      name: "作者库",
      component: () => import("@/views/resourceLibrary/index"),
    },
    {
      path: "/vocationalTraining/index",
      name: "作者库",
      component: () =>
        import("@/views/resourceLibrary/vocationalTraining/index"),
    },
    {
      path: "/app/newsDetail",
      name: "新闻详情",
      component: () => import("@/views/index/mobileNews"),
      meta: {
        title: "新闻详情",
      },
    },
    {
      path: "/willingLearn/index",
      component: () => import("@/views/willingLearn/index"),
      name: "国开乐学",
      meta: {
        hideMenu: true,
      },
      children: [
        {
          path: "/willingLearn/index/index",
          name: "乐学首页",
          meta: {
            hideMenu: true,
          },
          component: () => import("@/views/willingLearn/index/index"),
        },
        {
          path: "/willingLearn/bookstore",
          name: "书系列表",
          meta: {
            title: "书系列表",
            hideMenu: true,
          },
          component: () => import("@/views/willingLearn/bookstore/bookstore"),
        },
        {
          path: "/willingLearn/paper/testPaper",
          name: "开始考试",
          meta: {
            title: "开始考试",
            hideMenu: true,
          },
          component: () => import("@/views/willingLearn/paper/testPaper"),
        },
        {
          path: "/willingLearn/paper/errorPaper",
          name: "开始考试",
          meta: {
            title: "开始考试",
            hideMenu: true,
          },
          component: () => import("@/views/willingLearn/paper/errorPaper"),
        },
      ],
    },
    {
      path: "/IntegratedLogin",
      name: "开放页",
      component: () => import("@/views/IntegratedLogin/index")
    },
  ],
  // 解决路由跳转新页面，总是跳转页面底部
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
